import React, { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';
import store from "../../redux/store";
import { APP_CONFIG } from "../../config";

const RefreshSignalR = ({
  onTableStateChanged,
  onSignalRConnected,
  onSignalRDisconnected,
  table,
  refreshRate //milliseconds
}) => {
    const [hub, setHub] = useState(null);
    const [tableState, setTableState] = useState({ LastModified: null, Rows: 0 });
    const [stateUpdate, setStateUpdate] = useState(null);
    const [initialCallMade, setInitialCallMade] = useState(false);
    const accessToken = store.getState().authReducer.token;

    useEffect(() => {
        if (!accessToken) {
          console.log("No access token!"); // Sanity check as this is embedded to private route
          return;
        }
        const baseUrl = APP_CONFIG.baseURL.replace("/api/", "/refreshhub");
          // Create a new SignalR connection
        const hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(baseUrl + `?access_token=${encodeURIComponent(accessToken)}&domain=${encodeURIComponent(window.location.host)}`)  // Replace with your hub URL
            .configureLogging(signalR.LogLevel.Warning)
            .withAutomaticReconnect()
            .build();

        // Set server timeout to 60 seconds (60000 milliseconds)
        hubConnection.serverTimeoutInMilliseconds = 60000;
        //hubConnection.on("StateUpdate", onStateUpdate);
        hubConnection.on("StateUpdate", (message) => {
          // When a message is received, store it in state
          setStateUpdate(message);
        });

        // Set up event handlers
        hubConnection.onclose(() => {
            console.log("SignalR: Connection closed.");
            onSignalRDisconnected();
            setHub(null);
        });

        hubConnection.onreconnecting(() => {
            console.log("SignalR: Connection lost, reconnecting...");
            onSignalRDisconnected();
            setHub(null);
        });

        hubConnection.onreconnected((connectionId) => {
            console.log("SignalR: Reconnected with connection ID:", connectionId);
            onSignalRConnected();
            setHub(hubConnection);
        });

        // Start the connection
        hubConnection.start()
            .then(() => {
                console.log("SignalR: Connected to SignalR");
                onSignalRConnected();
                setHub(hubConnection);
            })
            .catch(err => {
                console.error("SignalR: Connection failed: ", err);
                onSignalRDisconnected();
                setHub(null);
            });

        // Clean up on component unmount
        return () => {
            hubConnection.stop().then(() => {
                console.log("SignalR: SignalR connection stopped.");
                onSignalRDisconnected();
                setHub(null);
            });
        };
    }, [accessToken]);

    useEffect(() => {
      if (!hub) {
        return () => clearInterval(interval);
      }
  
      // Periodically send checkState message - our pooling mechanism
      const interval = setInterval(() => {
        checkState();
      }, refreshRate);
  
      return () => clearInterval(interval);
    }, [hub]);
  
    useEffect(() => {
      console.log("table state changed: " + table + ",rows=" + tableState.Rows + ",initialCallMade=" + initialCallMade);
      if (tableState.Rows > 0) {
          // Prevent double data read on initialization
        if (initialCallMade === false) {
          setInitialCallMade(true);
        } else {
          onTableStateChanged();
        }
      }
    }, [tableState]);
  
    useEffect(() => {
      if (stateUpdate) {
        // Check if the new state is different from the current state
         if (
          stateUpdate.LastModified !== tableState.LastModified ||
          stateUpdate.Rows !== tableState.Rows
        ) {
          // Update the main state object only if the message is different
          setTableState((prevState) => ({
            ...prevState,
            LastModified: stateUpdate.LastModified,
            Rows: stateUpdate.Rows
          }));
        }
      }
    }, [stateUpdate, tableState]);

    // Invoke method to refresh table state
    const checkState = () => {
      if (hub == null) {
        return;
      }
      //console.log("SignalR, Sent checkState");
      hub.invoke("checkState", table);
    };

  return <React.Fragment></React.Fragment>;
};

export default RefreshSignalR;



// WEBPACK FOOTER //
// ./src/components/signalr/refresh-signalr.js